<sd-modal-default
  (isOpenedChange)="isOpenedChange.emit($event)"
  [(isOpened)]="isOpened"
  modalCustomClass="c__product-seller-modal"
  [modalTitle]="'product.modalLogistician.title' | translate"
  [modalTitleLevel]="4"
  [clickToClose]="true"
>
  <p>
    {{ 'product.modalLogistician.explanation' | translate }}
  </p>
  <div class="c__description">
    <sd-icon name="icon-brand-xs" [size]="iconSize.small" />
    <p>
      {{ 'product.modalLogistician.shopLogistician' | translate }}
    </p>
  </div>
  <div class="c__description">
    <sd-icon name="icon-seller-accessories" [size]="iconSize.small" />
    <p>
      {{ 'product.modalLogistician.sellerLogistician' | translate }}
    </p>
  </div>
  <p>
    {{ 'product.modalLogistician.conclusion' | translate }}
  </p>
</sd-modal-default>
